import HelpTip from '../../../components/HelpTip';

interface ModelOption {
  platform: string;
  model: string;
  displayName?: string;
}

interface PlatformModelSelectSectionProps<T extends ModelOption> {
  title: string;
  titleTip: string;
  models: T[];
  platform: string;
  model: string;
  emptyLabel: string;
  onPlatformChange: (platform: string, firstModel?: string) => void;
  onModelChange: (model: string) => void;
}

const OPTION_SEPARATOR = '::';

const buildOptionValue = (platform: string, model: string): string =>
  `${platform}${OPTION_SEPARATOR}${model}`;

const parseOptionValue = (value: string): { platform: string; model: string } => {
  const idx = value.indexOf(OPTION_SEPARATOR);
  if (idx < 0) return { platform: '', model: value };
  return { platform: value.slice(0, idx), model: value.slice(idx + OPTION_SEPARATOR.length) };
};

export default function PlatformModelSelectSection<T extends ModelOption>({
  title,
  titleTip,
  models,
  platform,
  model,
  emptyLabel,
  onPlatformChange,
  onModelChange,
}: PlatformModelSelectSectionProps<T>) {
  const currentValue = buildOptionValue(platform, model);

  return (
    <div>
      <label className="form-label" style={{ marginBottom: '0.35rem' }}>
        {title}
        <HelpTip text={titleTip} />
      </label>
      {models.length > 0 ? (
        <select
          className="input"
          value={currentValue}
          onChange={event => {
            const { platform: nextPlatform, model: nextModel } = parseOptionValue(event.target.value);
            if (nextPlatform !== platform) {
              onPlatformChange(nextPlatform, nextModel);
            }
            onModelChange(nextModel);
          }}
          style={{ fontSize: '0.875rem' }}
        >
          {models.map(item => (
            <option key={buildOptionValue(item.platform, item.model)} value={buildOptionValue(item.platform, item.model)}>
              {item.displayName || item.model}
            </option>
          ))}
        </select>
      ) : (
        <div style={{ fontSize: '0.8rem', color: 'var(--text-3)', padding: '0.5rem 0' }}>
          {emptyLabel}
        </div>
      )}
    </div>
  );
}
